export const checkUserAccess = (userRole, allowedRoles) => {
	return allowedRoles.includes(userRole);
}

export default checkUserAccess;